export enum ReservationStatus {
  Confirm = 'Confirm',
  Confirmed = 'Confirmed',
  OnHold = 'OnHold',
  Solicited = 'Solicited',
  Processing = 'Processing',
  Canceled = 'Canceled',
  Cancelled = 'Cancelled',
  Expired = 'Expired',
  Failed = 'Failed',
  Available = 'Available',
  Exchanged = 'Exchanged',
  PendingChange = 'InChange',
  Optimizing = 'Optimizing'
}

export enum PaymentReservationStatus {
  Approved = 'Approved',
  ParciallyApproved = 'ParciallyApproved',
  NotApproved = 'NotApproved',
  NoPayments = 'NoPayments',
  Paid = 'Paid',
  ParciallyPaid = 'ParciallyPaid',
  Refunded = 'Refunded',
  PendingPayment = 'PendingPayment',
}
